<!--ICONES MENUS-->
<div #leftmenu id="left-menu" class="root animated">

  <div class="left-app-menu-container">
    <div id="logo-container"
         class="pointer zoom-items"
         [class.menu-opened]="isSideMenuOpened">
      <yo-svg class="logo-large" src="assets/images/datameal-logo.svg"
              routerLink="/monbureau"
              [title]="NAV_KEY.MON_BUREAU">
      </yo-svg>
      <yo-svg class="logo-small hidden"
              src="assets/images/reduce-datameal-logo.svg"
              routerLink="/monbureau"
              [title]="NAV_KEY.MON_BUREAU">
      </yo-svg>
    </div>

    <div class="scroll-container">
      <ng-container *ngFor="let item of itemNavSvc.menuItems;  index as i;">
        <ng-container
          *ngTemplateOutlet="tplItemFlMenu;context:{item:item,index:i}">
        </ng-container>
      </ng-container>
    </div>
    <p-tieredMenu #menu
                  appendTo="body"
                  styleClass="{{isSideMenuOpened ? 'panel-opened' : 'panel-closed'}}"
                  [popup]="true"
                  [model]="subMenuItems"></p-tieredMenu>
  </div>

  <div class="root-footer animated">
    <!--ICONE VERSION-->
    <yo-infos-version [showArrow]="true" position="top">
      <div class="navigation-item"
           [class.menu-opened]="isSideMenuOpened"
           [routerLink]="['/changelogs']"
           title="Version">
        <div class="flex-container pointer zoom-items">
          <div class="item-container pointer">
            <i id="versionIcon"
               class="fa-question-circle far sidebar-icon item-icon site-secondaire-color"></i>
            <span  class="sidebar-label white ng-star-inserted">Version</span>
          </div>
        </div>
      </div>
    </yo-infos-version>

    <div class="navigation-item"
         [class.menu-opened]="isSideMenuOpened"
         (click)="toggleSideMenu()"
         title="Agrandir">
      <div class="flex-container pointer zoom-items">
        <div class="item-container pointer">
          <i
            id="toggleMenuIcon"
            class="fas fa-angle-double-right item-icon pointer cursor animated"
            [class.reverse]="isSideMenuOpened">
          </i>
          <span class="item-label pointer white unselectable">Réduire</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!--TEMPLATE ICON MENU FIRST LEVEL-->
<ng-template #tplItemFlMenu let-item="item" let-index="index">

  <ng-container *ngIf="item.label !== NAV_KEY.MON_BUREAU">
    <!--        HACK PRIMENG pour positionner le menu en haut à droite de l'élément-->
    <div [attr.id]="'submenudolapp'+index" (click)="openRealMenu(item,menu,$event)">
    </div>
    <div
         [id]="navKeyToHtmlId(item.label)"
         class="navigation-item"
         [class.menu-opened]="isSideMenuOpened"
         [class.selected]="itemNavSvc.selectedFlMenuItem === item"
         [class.pre-selected]="itemNavSvc.newFlMenuItem === item "
         (click)="openMenu('submenudolapp' + index, menu)"
         [title]="item.label">
      <div class="flex-container pointer zoom-items">
        <div class="item-container pointer">
          <i [attr.class]="item.icon + ' item-icon cursor'"></i>
          <label
            [title]="item.label"
            class="item-label pointer unselectable">{{ item.label }}</label>
        </div>
      </div>
      <i *ngIf="item.items?.length > 0" class="fas fa-2xs fa-chevron-right item-icon cursor"></i>
    </div>
  </ng-container>
</ng-template>
